export enum ErrorType {
  Unknown,
  ThresholdViolation,
  PastShipDate,
  ScheduleError,
  MissingTrailer,
  FileSizeError,
  Hd3Error,
  MissingContent,
  MissingPublicity,
  All
}
